module.exports = __webpack_public_path__ + "img/CHN.c703edfc.svg";